module.exports = require('./helpers/bundle-url').getBundleURL('hcTqB') + "HubspotLogo.9129630f.svg";